import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  useDataProvider,
  required,
  FormDataConsumer,
  NumberInput,
} from 'react-admin';
import ItemSelectInput from '../../components/ItemSelectInput.tsx'; // 根据实际路径调整
import UnitInput from '../../components/UnitInput.tsx';

const BomCreate = () => {
  const dataProvider = useDataProvider();

  const [finishedGoods, setFinishedGoods] = useState<any[]>([]);
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const [packagingMaterials, setPackagingMaterials] = useState<any[]>([]);

  useEffect(() => {
    setLoading(true);

    Promise.all([
      dataProvider.getList('bom/getFinishedGoodsSelectInputNew', {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: 'productId', order: 'ASC' },
        filter: { type: 'FinishedGood' },
      }),
      dataProvider.getList('bom/getFinishedGoodsSelectInput', {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: 'productId', order: 'ASC' },
        filter: { type: 'RawMaterial' },
      }),
      dataProvider.getList('bom/getFinishedGoodsSelectInput', {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: 'productId', order: 'ASC' },
        filter: { type: 'PackagingMaterial' },
      }),
    ])
      .then(([finishedGoodsRes, rawMaterialsRes, packagingMaterialsRes]) => {
        setFinishedGoods(finishedGoodsRes.data);
        setRawMaterials(rawMaterialsRes.data);
        setPackagingMaterials(packagingMaterialsRes.data);

        setLoading(false);
      })
      .catch(e => {
        setError(e);
        setLoading(false);
      });
  }, [dataProvider]);

  if (loading) return <span>Loading...</span>;
  if (error) return <span>Error loading product options</span>;

  return (
    <Create
      transform={(data) => {
        const bomId = data.bomId ?? data.id;

        const toId = (m: any) =>
          typeof m === "object" ? (m.productId ?? m.id) : m;

        // 先处理 items
        const items = (data.items ?? []).map((item: any) => {
          const id = toId(item.material ?? item.productId);
          const unit = item["material.unit"] ?? item.unit ?? null;
          return {
            bomId,
            productId: id,
            quantity: Number(item.quantity) || 0,
            unit,
            proportion: Number(item.proportion) || 0,
          };
        });

        // 把 packagingItems 合并到 items
        const packagingAsItems = (data.packagingItems ?? []).map((item: any) => {
          const id = toId(item.material ?? item.productId);
          const unit = item["material.unit"] ?? item.unit ?? null;
          return {
            bomId,
            productId: id,
            quantity: Number(item.quantity) || 0,
            unit,
            proportion: 0, // 包材一般没有配比，可以固定 0
          };
        });

        return {
          ...data,
          bomId,
          productId: toId(data.productId),
          items: [...items, ...packagingAsItems],

        };
      }}

    >
      <SimpleForm>
        {/* FinishedGood 选项传入 */}
        <ItemSelectInput sx={{
          '& .MuiAutocomplete-inputRoot': {
            minHeight: 50, // 你想要的高度
            height: 50,
            alignItems: 'center',
          },
          // 兼容 SelectInput
          '& .MuiInputBase-root': {
            minHeight: 50,
            height: 50,
            alignItems: 'center',
          },
        }} choices={finishedGoods} />

        {/* 其他字段 */}
        {/* <TextInput className="custom-text-input" source="version" /> */}
        <TextInput className="custom-text-input" source="blendSize" label='blend(kg)' />
        {/* <TextInput className="custom-text-input" source="lossRate" label='lossRate(%)' /> */}

        <ArrayInput source="items" label="Raw Materials">
          <SimpleFormIterator
            inline
            fullWidth
            sx={{
              '& .RaSimpleFormIterator-line': { mt: 2 },
              '& .RaSimpleFormIterator-field': { mt: 2 },
              '& .RaSimpleFormIterator-action': { mt: 2 },
            }}
          >
            {/* RawMaterial 选项传入 */}
            <ItemSelectInput
              sx={{
                '& .MuiAutocomplete-inputRoot': {
                  minHeight: 50, // 你想要的高度
                  height: 50,
                  alignItems: 'center',
                },
                // 兼容 SelectInput
                '& .MuiInputBase-root': {
                  minHeight: 50,
                  height: 50,
                  alignItems: 'center',
                },
              }}
              choices={rawMaterials}
              showSearch
              source="material"

            />
            <TextInput sx={{ mt: 1 }} source="quantity" label="quantity" />

            {/* <UnitInput
              source="material.unit"
              arrayName="items" ></UnitInput>  */}

            {/* <TextInput sx={{ mt: 1 }} label="proportion(%)" source="proportion" /> */}
          </SimpleFormIterator>
        </ArrayInput>
        {/* 新增包装材料 ArrayInput */}
        <ArrayInput source="packagingItems" label="Packaging Materials">
          <SimpleFormIterator inline fullWidth sx={{
            '& .RaSimpleFormIterator-line': { mt: 2 },
            '& .RaSimpleFormIterator-field': { mt: 2 },
            '& .RaSimpleFormIterator-action': { mt: 2 },
          }}>
            <ItemSelectInput
              sx={{
                '& .MuiAutocomplete-inputRoot': {
                  minHeight: 50,
                  height: 50,
                  alignItems: 'center',
                },
                '& .MuiInputBase-root': {
                  minHeight: 50,
                  height: 50,
                  alignItems: 'center',
                },
              }}
              choices={packagingMaterials}
              showSearch
              source="material"
            />
            <TextInput sx={{ mt: 1 }} source="quantity" label="quantity" />
            {/* <UnitInput source="material.unit" arrayName="packagingItems" /> */}
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default BomCreate;
